import { useState } from 'react'

import { RowClickedEvent } from 'ag-grid-enterprise'

import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'
import { CustomAgGridProps } from '@fortem-monorepo/react-ag'
import { Widget, WidgetContent, WidgetHeaderWithQuery } from '@fortem-monorepo/react-spa'
import { useUserContext } from '@fortem-monorepo/react-spa'
import { Swapagg } from '@fortem-monorepo/web-sdk'

import { useOpsContext } from '@/pages/operations/ops-context.context'

export interface MissingMappingsTableProps extends CustomAgGridProps {}

export const MissingMappingsTable: React.FC<MissingMappingsTableProps> = ({
  query,
  rowData,
  ...props
}) => {
  const { hasPermissions } = useUserContext()
  const { createNewMapping } = useOpsContext()

  const hasWriteAccess = hasPermissions((permissions) => ({
    permissions: [permissions.WRITE_MAPPINGS],
  }))

  const [newMissingMappingColDefs] = useState(
    createColDefs([
      { field: 'instrument_type' },
      { field: 'structurename' },
      { field: 'fund_name' },
      { field: 'Bank' },
      { field: 'Custodian' },
      { field: 'instrument_id', hide: true },
      { field: 'instrument_type_id', hide: true },
    ]),
  )

  return (
    <Widget exposed className={'h-full'}>
      <WidgetHeaderWithQuery query={query} title="Missing Mappings" />
      <WidgetContent loading={query?.isLoading}>
        <CustomAgGrid
          cellSelection={false}
          rowClassRules={{
            ['cursor-pointer']: () => hasWriteAccess,
          }}
          onRowClicked={
            hasWriteAccess
              ? (e: RowClickedEvent<Swapagg.MissingExternalMapping>) => {
                  createNewMapping({
                    structurename: e.data?.structurename,
                    provider: '',
                    is_agent_id: !!e.data?.Bank && !!!e.data?.Custodian,
                    external_id: '',
                    from_date: '',
                    agentIdDisabled: !!e.data?.Bank || !!e.data?.Custodian,
                  })
                }
              : undefined
          }
          suppressCellFocus
          selectionColumnDef={{
            pinned: 'left',
          }}
          columnDefs={newMissingMappingColDefs}
          rowData={rowData}
          {...props}
        />
      </WidgetContent>
    </Widget>
  )
}
